(function closure(root, factory) {
  /* istanbul ignore else  */
  if (typeof define === 'function' && define.amd) {
    define('header.homedecorfurnitureflyout', ['jquery', 'mustache', 'header.data', 'header.analytics', 'hoverIntent'],
      function load(jQuery, Mustache, headerData, headerAnalytics) {
        return factory(root, jQuery, Mustache, headerData, headerAnalytics);
      });
  } else {
    // For non-AMD module, expose this to global (will also be useful for test cases)
    /*eslint-disable*/
    var _hfapp = THD.Utility.Namespace.createNamespace('THD.HFApp');
    _hfapp.homeDecorFurnitureFlyout = factory(root, jQuery, Mustache, THD.HFApp.data, THD.HFApp.analytics, $.hoverIntent);
    /*eslint-enable*/
  }
})(this, function factory(root, $, Mustache, headerData, headerAnalytics) {
  var homeDecorFurnitureFlyout = {};
  var homeDecorFurnitureData = null;
  var privateMethods = {};

  privateMethods.templates = {};

  privateMethods.templates.subnav =
    '<ul class="homeDecorFurniture__list">' +
    '    <li>' +
    '        <a class="homeDecorFurniture__link" href="//www.homedepot.com/b/Home-Decor/N-5yc1vZas6p" id="home-decor">Home Decor</a>' +
    '    </li>' +
    '    <li>' +
    '        <a class="homeDecorFurniture__link" href="//www.homedepot.com/b/Furniture/N-5yc1vZc7pc" id="furniture">Furniture</a>' +
    '    </li>' +
    '    <li>' +
    '        <a class="homeDecorFurniture__link" href="//www.homedepot.com/b/Kitchen-Kitchenware/N-5yc1vZaqzo" id="kitchen-and-dining">Kitchen & Dining</a>' +
    '    </li>' +
    '    <li>' +
    '        <a class="homeDecorFurniture__link" href="//www.homedepot.com/b/Home-Decor-Bedding-Bath/N-5yc1vZci04" id="bedding-and-bath">Bedding & Bath</a>' +
    '    </li>' +
    '    <li>' +
    '        <a class="homeDecorFurniture__link" href="//www.homedepot.com/b/Lighting/N-5yc1vZbvn5" id="lighting">Lighting</a>' +
    '    </li>' +
    '    <li>' +
    '        <a class="homeDecorFurniture__link" href="//www.homedepot.com/b/Window-Treatments/N-5yc1vZar4w" id="window-treatments">Window Treatments</a>' +
    '    </li>' +
    '    <li>' +
    '        <a class="homeDecorFurniture__link" href="//www.homedepot.com/room" id="shop-by-room">Shop by Room</a>' +
    '    </li>' +
    '    <li>' +
    '        <a class="homeDecorFurniture__link" href="//www.homedepot.com/c/Savings_Center" id="savings">Savings</a>' +
    '    </li>' +
    '</ul>';

  privateMethods.templates.normalFlyout =
    '{{#columns}} ' +
    '    <div class="homeDecorFurniture__column {{#showSeparator}}homeDecorFurniture__column--separator{{/showSeparator}}">' +
    '        {{#bays}} ' +
    '        <div class="homeDecorFurniture__bay">' +
    '            {{#imageURL}} ' +
    '            <div class="homeDecorFurniture__bayImage">' +
    '                <a class="homeDecorFurniture__endpoint homeDecorFurniture__endpoint--image" style="background-image:url({{imageURL}})" href="{{bayLink}}"></a>' +
    '            </div>' +
    '            {{/imageURL}} ' +
    '            {{#bayLink}} ' +
    '            <div class="homeDecorFurniture__bayName">' +
    '                <a class="homeDecorFurniture__endpoint" href="{{bayLink}}">' +
    '                    {{bayName}} ' +
    '                </a>' +
    '            </div>' +
    '            {{/bayLink}} ' +
    '            {{^bayLink}} ' +
    '            <div class="homeDecorFurniture__bayName">' +
    '                {{bayName}} ' +
    '            </div>' +
    '            {{/bayLink}} ' +
    '            {{#shelves}} ' +
    '            <div class="homeDecorFurniture__bayShelf">' +
    '                {{#shelfLink}} ' +
    '                    <a class="homeDecorFurniture__endpoint" href="{{shelfLink}}">' +
    '                        {{shelfName}} ' +
    '                    </a>' +
    '                {{/shelfLink}} ' +
    '                {{^shelfLink}} ' +
    '                    {{shelfName}} ' +
    '                {{/shelfLink}} ' +
    '            </div>' +
    '            {{/shelves}} ' +
    '        </div>' +
    '        {{/bays}} ' +
    '    </div>' +
    '{{/columns}}';

  privateMethods.templates.shopByRoomFlyout =
    '<div class="homeDecorFurniture__shopByRoom">' +
    '    {{#bays}} ' +
    '        <div class="homeDecorFurniture__room">' +
    '            <a class="homeDecorFurniture__endpoint homeDecorFurniture__roomImage homeDecorFurniture__endpoint--image" style="background-image:url({{imageURL}})" href="{{link}}"></a>' +
    '            <a class="homeDecorFurniture__endpoint homeDecorFurniture__roomName" href="{{link}}">' +
    '                {{roomName}} ' +
    '            </a>' +
    '        </div>' +
    '    {{/bays}} ' +
    '</div>';

  privateMethods.analyticsSelectedAisle = null;

  privateMethods.clearUrl = function _clearUrl(urlString) {
    // Need to ensure this value isn't just a placeholder
    // if it is, we need to remove the string so Mustache can tell.
    return urlString === '#' ? '' : urlString;
  };

  privateMethods.getFlyoutData = function getFlyoutData() {
    if (!homeDecorFurnitureData) {
      var jsonPath = '/hdus/en_US/DTCCOMNEW/fetch/homeDecorFurnitureFlyout.json';
      var responseDataPromise = headerData.getEtchJSON(jsonPath);

      responseDataPromise.then(function _responseDataPromise(jsonResponse) {
        homeDecorFurnitureData = jsonResponse;

        // Process all elements to Mustache can understand
        if (homeDecorFurnitureData.aisles) {
          homeDecorFurnitureData.aisles.forEach(function _processAisle(aisle) {
            if (aisle.columns) {
              aisle.columns.forEach(function _processColumn(column) {
                if (column.bays) {
                  column.bays.forEach(function _processBay(bay) {
                    if (bay.name) {
                      bay.bayName = bay.name;
                    }
                    if (bay.link) {
                      bay.bayLink = bay.link;
                    }
                    if (bay.shelves) {
                      bay.shelves.forEach(function _processShelf(shelf) {
                        if (shelf.name) {
                          shelf.shelfName = shelf.name;
                        }
                        if (shelf.link) {
                          shelf.shelfLink = shelf.link;
                        }
                      });
                    }
                  });
                }
              });
            } else if (aisle.bays && aisle.name === 'Shop by Room') {
              aisle.bays.forEach(function _processRoom(room) {
                room.roomName = room.name;
              });
            }
          });
        }
      });
    }
  };

  privateMethods.highlightLink = function _highlightLink($menu, $item) {
    $('.homeDecorFurniture__link--active', $menu).removeClass('homeDecorFurniture__link--active');
    $item.addClass('homeDecorFurniture__link--active');
  };

  privateMethods.interactWithAisle = function _interactWithAisle(event) {
    var $this = $(event.target);

    if (event.type === 'hoverintent') {
      privateMethods.stopTouchHandling(event);
      privateMethods.highlightLink('.homeDecorFurniture__subnav', $this);
      privateMethods.renderFlyout($this.text());
    } else {
      privateMethods.analyticsSelectedAisle = $this.text().toLowerCase().replace('&', 'and').trim();
      privateMethods.logInteractionForL2();
    }
  };

  privateMethods.logEventPath = function _logEventPath(type, pathArray) {
    // Get header at the beginning, then join them all
    var level1 = 'home decor and furniture';
    return headerAnalytics.logEvent(type, ['header', level1].concat(pathArray).join('>'));
  };

  privateMethods.logInteractionForL2 = function _logInteractionForL2() {
    // L2 is an aisle in the subnav
    var level2 = privateMethods.analyticsSelectedAisle;
    return privateMethods.logEventPath('header click', [level2]);
  };

  privateMethods.logInteractionForL3 = function _logInteractionForL3() {
    // L3 is either a bay, shelf, or room in the flyout
    var level2 = privateMethods.analyticsSelectedAisle;

    // if the user clicked on bay or shelf, then use corresponding text
    // else use "catalog image" since that is the only L3 without text
    var level3 =
      $(this).text() ?
        $(this).text().toLowerCase().replace('&', 'and').trim() : 'catalog image';

    return privateMethods.logEventPath('header click', [level2, level3]);
  };

  privateMethods.registerHoverIntent = function _registerHoverIntent(selector) {
    $(document).hoverIntent({
      selector: selector,
      over: privateMethods.triggerHoverIntent,
      out: $.noop
    });
  };

  privateMethods.renderFlyout = function _renderFlyout(aisleName) {
    if (homeDecorFurnitureData) {
      privateMethods.analyticsSelectedAisle = aisleName.toLowerCase().replace('&', 'and').trim();

      var flyoutSelector = $('.homeDecorFurniture__flyout');

      var htmlContent;

      var aisle;
      homeDecorFurnitureData.aisles.forEach(function _findAisle(element) {
        if (element.name === aisleName) {
          aisle = element;
        }
      });

      if (aisleName === 'Shop by Room') {
        htmlContent = Mustache.render(privateMethods.templates.shopByRoomFlyout, aisle);
      } else {
        aisle.columns.forEach(function (column) {
          if (!column.bays || column.bays.length === 0) {
            column.showSeparator = false;
          } else {
            column.bays.forEach(function (bay) {
              bay.imageURL ? column.showSeparator = false : column.showSeparator = true;
            });
          }
        });
        htmlContent = Mustache.render(privateMethods.templates.normalFlyout, aisle);
      }

      flyoutSelector.html(htmlContent);
    }
  };

  privateMethods.renderSubnav = function _renderSubnav() {
    $('.homeDecorFurniture__subnav').html(Mustache.render(privateMethods.templates.subnav));
  };

  privateMethods.setMenuState = function _setMenuState(state) {
    $('.homeDecorFurniture')
      .toggleClass('homeDecorFurniture', (state === 'bay'));
  };

  privateMethods.stopTouchHandling = function _stopTouchHandling(event) {
    // If this is a touch interaction
    if (event.type === 'touchend') {
      // Prevent the normal behavior
      event.preventDefault();
      event.stopPropagation();
    }
  };

  privateMethods.triggerHoverIntent = function _triggerHoverIntent() {
    $(this).trigger({
      type: 'hoverintent',
      target: this
    });
  };

  // bind to all the necessary elements
  privateMethods.initialize = function initialize() {
    $(document)
      .on('click touchend hoverintent', '.Header3 .ShoppingLinks__link[data-id="homeDecorFurniture"]', privateMethods.getFlyoutData)
      .hoverIntent({
        selector: '.Header3 .ShoppingLinks__link[data-id="homeDecorFurniture"]',
        over: privateMethods.triggerHoverIntent,
        out: $.noop
      });
    $(document)
      .on('click touchend hoverintent', '.homeDecorFurniture__subnav .homeDecorFurniture__link', privateMethods.interactWithAisle)
      .on('click touchend', '.homeDecorFurniture__flyout .homeDecorFurniture__endpoint', privateMethods.logInteractionForL3);

    privateMethods.registerHoverIntent('.homeDecorFurniture__link');
  };

  /*
   * Public Methods
   */

  homeDecorFurnitureFlyout.init = function init() {
    privateMethods.initialize();
    headerData.init();
    privateMethods.renderSubnav();

    return this;
  };

  homeDecorFurnitureFlyout.getPrivateMethods = function getPrivateMethods() {
    return privateMethods;
  };

  homeDecorFurnitureFlyout.getHomeDecorFurnitureData = function getHomeDecorFurnitureData() {
    return homeDecorFurnitureData;
  };

  return homeDecorFurnitureFlyout;
});
